import { Config } from './types'
import { formatDegree, formatFloat } from './GraphParamDefs'
import { currFormula } from './Formulas'

export const formattedTimeStamp = (timestamp: number, isIncludeYear?: boolean) => {
  const date = new Date(timestamp)
  const year = date.getUTCFullYear()
  const padNum = (num: number): string => num.toString().padStart(2, '0')
  const month = padNum(date.getUTCMonth() + 1)
  const day = padNum(date.getUTCDate())
  const hour = padNum(date.getUTCHours())
  const minute = padNum(date.getUTCMinutes())
  const yearPart = isIncludeYear ? `${year}-` : ''
  const timezone = isIncludeYear ? ' GMT' : ' '
  return `${yearPart}${month}-${day} ${hour}:${minute}${timezone}`
}

export const getFormulaText = (config: Config): string => {
  const {
    strokeColor,
    fillColor,
    step,
    progress: thetaRange,
    zoom,
    vert,
    horiz,
    bgColor,
    cycles,
    isUseBgColor,
    isFillShape,
    isVisibleStroke,
    strokeWidth,
    rotX,
    rotY,
    rotZ,
    frustum,
    isFlip,
  } = config
  const plotter = currFormula(config)
  const { isPolar } = plotter
  const label = plotter.label()
  const stepStr = formatFloat(step)
  const progressStr = formatFloat(thetaRange)
  const degreeStepStr = cycles > 1 ? `${stepStr}/${formatFloat(cycles)}` : stepStr
  const rangeEnd = step === 1 ? progressStr : `${progressStr}*${stepStr}`
  const range = `${isPolar ? '\u03b8' : 'x'}=0..${rangeEnd} \u03b4=${degreeStepStr}`
  const where = `(${horiz},${vert},${zoom}) (${formatDegree(rotX)},${formatDegree(
    rotY
  )},${formatDegree(rotZ)},${frustum}${isFlip ? '§' : ''})`
  const stroke = `${isVisibleStroke ? strokeColor.substring(1) : ''}`
  const strokeInfo = strokeWidth !== 1.0 ? ` ${formatFloat(strokeWidth)}` : ''
  const fill = `${isFillShape ? fillColor.substring(1) : ''}`
  const bg = `${isUseBgColor ? bgColor.substring(1) : ''}`
  const colors = `${stroke}.${bg}.${fill}${strokeInfo}`
  const legend = `${label} ${range} ${where} ${colors}`
  return legend
}

const DOWNSCALE_STEP = 0.7

export const highQualityDownscale = (sourceCanvas: HTMLCanvasElement, targetWidth: number) => {
  const ratio = sourceCanvas.width / sourceCanvas.height
  const targetHeight = targetWidth / ratio
  let currentCanvas = sourceCanvas
  // Step-down until we're close to the target
  while (currentCanvas.width * DOWNSCALE_STEP > targetWidth) {
    const tempCanvas = document.createElement('canvas')
    tempCanvas.width = currentCanvas.width * DOWNSCALE_STEP
    tempCanvas.height = currentCanvas.height * DOWNSCALE_STEP

    const ctx = tempCanvas.getContext('2d')
    if (!ctx) {
      throw new Error('no context')
    }
    ctx.imageSmoothingEnabled = true
    ctx.imageSmoothingQuality = 'high'
    ctx.drawImage(currentCanvas, 0, 0, tempCanvas.width, tempCanvas.height)

    currentCanvas = tempCanvas
  }
  // Final resize to exact target size
  const finalCanvas = document.createElement('canvas')
  finalCanvas.width = targetWidth
  finalCanvas.height = targetHeight

  const finalCtx = finalCanvas.getContext('2d')
  if (!finalCtx) {
    throw new Error('no context')
  }
  finalCtx.imageSmoothingEnabled = true
  finalCtx.imageSmoothingQuality = 'high'
  finalCtx.drawImage(currentCanvas, 0, 0, finalCanvas.width, finalCanvas.height)

  return finalCanvas
}
export const shuffle = <T>(array: T[]): T[] => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}
